module.exports = __webpack_public_path__ + "static/media/postscript.8571d371.svg";